import { Colors } from 'constants/ui';

export const ICON_SIZE = 40;
export const ACCENT = Colors.accent;
export const ACCENT_LIGHT = Colors.accentLight;
